import { render } from "./NTabs.vue?vue&type=template&id=47ed6c6a&ts=true"
import script from "./NTabs.vue?vue&type=script&lang=ts"
export * from "./NTabs.vue?vue&type=script&lang=ts"

import "./NTabs.vue?vue&type=style&index=0&id=47ed6c6a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__